import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";
import { AI_getProjectList } from "./project";

export const AI_getProjectEmployeeList = apiBase.createListInstance({
    endpoint: "/project-employee/",
    method: "get",
    reducer: "projectEmployeeReducer",
    key: "id",
    reduxKey: "ProjectEmployeeData",
    action: "GET_PROJECTEMPLOYEE_LIST",
    listPath:"data.rows",
    onSuccess: (data) => data.project_employee
});

export const AI_deleteProjectEmployee = apiBase.createInstance({
    endpoint: "/project-employee",
    method: "delete",
    reducer: "projectEmployeeReducer",
    reduxKey: "deleteProjectEmployeeData",
    action: "DELETE_PROJECTEMPLOYEE",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            data.project_employees
        )
    }
});

export const AI_addProjectEmployee = apiBase.createInstance({
    endpoint: "/project-employee",
    method: "post",
    reducer: "projectEmployeeReducer",
    reduxKey: "addProjectEmployeeData",
    action: "ADD_PROJECTEMPLOYEE",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            data.project_employee
        )
    }
});

export const AI_updateProjectEmployee = apiBase.createInstance({
    endpoint: "/project-employee/{id}",
    method: "put",
    reducer: "projectEmployeeReducer",
    reduxKey: "updateProjectEmployeeData",
    action: "UPDATE_PROJECTEMPLOYEE",
    middleware : notificationMiddleWare,
    listPath:"data.rows",
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            [
                data.project_employee
            ]
        )
    }
});

export const AI_showProjectEmployeeList = apiBase.createListInstance({
    endpoint: "/show-employee/{id}",
    method: "get",
    reducer: "projectEmployeeReducer",
    key: "id",
    reduxKey: "ProjectEmployeeData",
    action: "SHOW_PROJECTEMPLOYEE_LIST",
    onSuccess: (data) => data.employee
});

export const AI_showProjectTree = apiBase.createListInstance({
    endpoint: "/project-tree-view",
    method: "get",
    reducer: "projectEmployeeReducer",
    key: "id",
    reduxKey: "ProjectTreeData",
    action: "SHOW_PROJECTEMPLOYEE_TREE",
    onSuccess: (data) => data.employee
});

export const AI_addProjectEmployeeNotes = apiBase.createInstance({
    endpoint: "/create-employee-notes",
    method: "post",
    reducer: "projectEmployeeReducer",
    reduxKey: "addProjectEmployeeNotesData",
    action: "ADD_PROJECTEMPLOYEE_NOTES",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            [data.notes]
        )
    }
});

export const AI_setWorkingProject = apiBase.createInstance({
    endpoint: "/start-working-on-project",
    method: "post",
    reducer: "projectEmployeeReducer",
    reduxKey: "setWorkingProject",
    action: "SET_WORKING_PROJECT",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            [data.project]
        )
    }
});
